import { useDeleteSize } from "http-hooks/size/useSize";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteSize({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteSize();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Size"
      description="Are you sure you want to delete this Size? This Size will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
